import LodChlSelect from "components/select/lod/lodChl";
import RmNmSelect from "components/select/rm/rmNo";
// import DatePick from "components/datePick";
import TableRow from "components/rows/tableRow";
import Select from "components/select";
import { dateTyps } from "components/utils/option";
import { useTranslation } from "react-i18next";
import { useResvFilterContext } from "./context";
import RmTypCd from "components/select/rm/rmTypCd";
import RmOlkCd from "components/select/rm/rmOlkCd";
import { SEARCH_FORM_ID_ROOM_RESV } from "components/constent";
import { useSubmit } from "./handles";
import Cell from "components/rows/cell";
import DateRangePicker from "components/datePicker";

export function SearchForm() {
  const { t } = useTranslation();
  const { filters, onChange, onSelect, onPickDate, onReset } =
    useResvFilterContext();
  const { onSubmit } = useSubmit();

  return (
    <>
      <form id={SEARCH_FORM_ID_ROOM_RESV} onSubmit={onSubmit} onReset={onReset}>
        <table>
          <tbody>
            <TableRow title={t("row_ttl_rm_pd")}>
              <ul>
                <li>
                  <label htmlFor="">{t("lbl_rmpd_chl")}</label>
                  <LodChlSelect
                    isReset={!filters.lodChlCd}
                    select={(lodChlCd) => onSelect("lodChlCd", lodChlCd)}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_filter_dt")}</label>
                  <Select
                    name={"dateTyp"}
                    defaultValue={dateTyps[0]}
                    styles="bg-white border-1"
                    options={dateTyps.slice(0, 2)}
                    isReset={!filters.dateTyp}
                    isInitialData={false}
                    onSelect={(option) => onSelect("dateTyp", option.code)}
                  />
                </li>
                <li>
                  <DateRangePicker
                    startNm="SDt"
                    endNm="EDt"
                    defaultStart={filters.sDt}
                    defaultEnd={filters.eDt}
                    onChange={onPickDate}
                  />
                  {/* <DatePick
                    startNm={"SDt"}
                    endNm={"EDt"}
                    defaultValue={[filters.sDt, filters.eDt]}
                    onPickDate={onPickDate}
                  /> */}
                </li>
                <li>
                  <Cell
                    label={t("lbl_resv_no")}
                    dataTyp="C"
                    name="rmResvNo"
                    value={filters.rmResvNo}
                    onChange={(e) =>
                      onChange("rmResvNo", e.currentTarget.value)
                    }
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_prom_cd")}
                    dataTyp="C"
                    name="promCd"
                    value={filters.promCd}
                    onChange={(e) => onChange("promCd", e.currentTarget.value)}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_prom_nm")}
                    dataTyp="C"
                    name="promNm"
                    value={filters.promNm}
                    onChange={(e) => onChange("promNm", e.currentTarget.value)}
                  />
                </li>
              </ul>
            </TableRow>
            <TableRow title={t("row_ttl_rm_inf")}>
              <ul>
                <li>
                  <label htmlFor="">{t("lbl_rm_nm")}</label>
                  <RmNmSelect
                    isReset={!filters.rmNo}
                    select={(rmNo) => {
                      onSelect("rmNo", rmNo);
                    }}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_rm_typ")}</label>
                  <RmTypCd
                    isReset={!filters.rmTypCd}
                    select={(rmTypCd) => onSelect("rmTypCd", rmTypCd)}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_rm_olk")}</label>
                  <RmOlkCd
                    isReset={!filters.rmOlkCd}
                    select={(rmOlkCd) => onSelect("rmOlkCd", rmOlkCd)}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_rm_op_nm")}
                    dataTyp="C"
                    name="rmOpNm"
                    value={filters.rmOpNm}
                    onChange={(e) => onChange("rmOpNm", e.currentTarget.value)}
                  />
                </li>
              </ul>
            </TableRow>

            <TableRow title={"고객정보"}>
              <ul>
                <li>
                  <Cell
                    label={t("lbl_cst_nm")}
                    name="resvCstFstnm"
                    dataTyp="C"
                    value={filters.resvCstFstnm}
                    onChange={(e) =>
                      onChange("resvCstFstnm", e.currentTarget.value)
                    }
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_cst_phone")}
                    name="resvCstMblNo"
                    value={filters.resvCstMblNo}
                    dataTyp="C"
                    onChange={(e) =>
                      onChange("resvCstMblNo", e.currentTarget.value)
                    }
                  />
                </li>
              </ul>
            </TableRow>
            <TableRow title={"회원정보"}>
              <ul>
                <li>
                  <Cell
                    label={t("lbl_cst_nm")}
                    name="resvMemFstnm"
                    value={filters.resvMemFstnm}
                    dataTyp="C"
                    onChange={(e) =>
                      onChange("resvMemFstnm", e.currentTarget.value)
                    }
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_cst_phone")}
                    name="resvMemMobNo"
                    value={filters.resvMemMobNo}
                    dataTyp="C"
                    onChange={(e) =>
                      onChange("resvMemMobNo", e.currentTarget.value)
                    }
                  />
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
}

const options = [
  {
    ko: "최대인원수",
    en: "Max Participants",
    value: "maxPerCtMax",
    code: "maxPerCtMax",
  },
  {
    ko: "최소인원수",
    en: " Min Participants",
    value: "maxPerCtMin",
    code: "maxPerCtMin",
  },
  {
    ko: "회원이름",
    en: "Member Name",
    value: "resvMemFstnm",
    code: "resvMemFstnm",
  },
  {
    ko: "회원전화번호",
    en: "	Member Phone Number",
    value: "resvMemMobNo",
    code: "resvMemMobNo",
  },
  {
    ko: "고객이름",
    en: "Customer Name",
    value: "resvCstFstnm",
    code: "resvCstFstnm",
  },
  {
    ko: "고객전화번호",
    en: "Customer Phone Number",
    value: "resvCstMblNo",
    code: "resvCstMblNo",
  },
];
